export default {
  mutations: {
    SET_DRAFTS_COMPANY: 'SET_DRAFTS_COMPANY',
    SET_DRAFTS_BRANCH: 'SET_DRAFTS_BRANCH',
    SET_SINGLE_DRAFT_COMPANY: 'SET_SINGLE_DRAFT_COMPANY',
  },
  getters: {
    GET_DRAFTS_COMPANIES: 'GET_DRAFTS_COMPANIES',
    GET_DRAFT_COMPANY: 'GET_DRAFT_COMPANY',
  },
  actions: {
    SAVE_DRAFT_COMPANY: 'SAVE_DRAFT_COMPANY',
    DRAFTS_COMPANIES_LIST: 'DRAFTS_COMPANIES_LIST',
    UPDATE_DRAFT_COMPANY: 'UPDATE_DRAFT_COMPANY',
    SINGLE_DRAFT_COMPANY: 'SINGLE_DRAFT_COMPANY',
    DELETE_DRAFT_BRANCH: 'DELETE_DRAFT_BRANCH',
    DELETE_DRAFT_CONTACT: 'DELETE_DRAFT_CONTACT',
    REGISTER_DRAFT_COMPANY: 'REGISTER_DRAFT_COMPANY',
    UPDATE_RESOURCES_DRAFT_COMMERCE: 'UPDATE_RESOURCES_DRAFT_COMMERCE',
  },
};
